<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_accordion',
		availableFor: ['pages'],
		query: gql`
        internal_name
        media {
            ...Media
        }
        translations {
            languages_code {
                code
            }
            section_title
            title
            text
        }
        items {
            section_accordion_item_id {
                translations {
                    languages_code {
                        code
                    }
                    title
                    text
                }
            }
        }


    
    `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		section_title: string;
		title: string;
		text: string;
		items: any;
		media: any;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import Accordion from '$lib/components/util/Accordion.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section gapType="padding" class="section-accordion" type={data.media ? 'normal' : 'slim'}>
	{#if data.section_title}
		<div class="section-title">{data.section_title}</div>
	{/if}
	{#if data.title}
		<div class="title">{data.title}</div>
	{/if}
	{#if data.text}
		<div class="text"><Wysiwyg text={data.text} /></div>
	{/if}
	<div class="accordion-wrapper">
		<div class="accordion-content">
			<Accordion
				items={data.items.map((item) => ({
					title: item.section_accordion_item_id.title,
					text: item.section_accordion_item_id.text
				}))}
			/>
		</div>
		{#if data.media}
			<div class="image">
				<Media {...data.media} fit="cover" transform="l" />
			</div>
		{/if}
	</div>
</Section>

<style lang="scss">
	:global(.section-accordion) {
		:global(.inner-section) {
			position: relative;
			overflow: hidden;
		}
	}

	.section-title {
		@include font(h6);
		margin-bottom: v(content-gap-xs);
	}
	.title {
		@include font(h2);
		max-width: 15ch;
		margin-bottom: v(content-gap);
	}
	.text {
		@include font(text);
		max-width: 50ch;
	}
	.accordion-content {
		max-width: v(max-width-slim);
		// max-height: 800px;
		flex: 1;
		:global(.accordion) {
			&.open {
				max-width: none;
			}
		}
		:global(.title) {
			border-top: 1px solid color(grey_03);
			padding-top: v(content-gap-sm) !important;
			padding-bottom: 0 !important;
		}

		:global(.text) {
			@include font(text);
			max-width: none !important;
		}
	}
	.accordion-wrapper {
		margin-top: v(content-gap-2xl);
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		gap: v(content-gap-2xl);
		@include media(phone) {
			margin-top: v(content-gap);
			flex-direction: column;
			gap: v(content-gap);
		}
		&:not(:has(.image)) {
			justify-content: center;
		}
	}
	.image {
		display: flex;
		:global(img) {
			width: 85%;
			aspect-ratio: 14 / 16;
			@media (max-width: 1100px) {
				width: 100%;
			}
			@include media(phone) {
				aspect-ratio: 0/1;
			}
		}
		flex: 1;
	}
</style>
